import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {UserEmailVerificationErrorPanelProps} from '@Panels/user-email-verification-error-panel/user-email-verification-error-panel.types';

export const openUserEmailVerificationErrorModal = (props: UserEmailVerificationErrorPanelProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.USER_EMAIL_VERIFICATION_ERROR_MODAL,
      isDismissible: props.isDismissable ?? true,
      panelProps: {
        ...props,
      },
    })
  );
};
